import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import DashboardIcon from "@material-ui/icons/Dashboard";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import CallToActionIcon from "@material-ui/icons/CallToAction";
import OpenWithIcon from "@material-ui/icons/OpenWith";

import { Link } from "react-router-dom";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    marginTop: "48px",
  },
  drawerContainer: {
    overflow: "auto",
    marginBottom: "100px",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  text: {
    fontWeight: "bold",
  },
}));

export default function ClippedDrawer() {
  const classes = useStyles();

  const [openAction, setOpenAction] = useState(false);
  const [openOps, setOpenOps] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);

  const handleClickAction = () => {
    setOpenAction(!openAction);
  };

  const handleClickOps = () => {
    setOpenOps(!openOps);
  };

  const handleClickAdmin = () => {
    setOpenAdmin(!openAdmin);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            <ListItem button component={Link} to="/">
              <ListItemIcon style={{ minWidth: "40px" }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.text }}
                primary="Dashboard"
              />
            </ListItem>

            <ListItem button onClick={handleClickAction}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <CallToActionIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.text }}
                primary="Action"
              />
              {openAction ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openAction} timeout="auto" unmountOnExit>
              <List component="div">
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/manageTeamsEndpoint/assign"
                >
                  <ListItemText secondary="Manage Teams Endpoint" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/manageQueueStatus"
                >
                  <ListItemText secondary="Manage Queue Status" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/editNumberStatus"
                >
                  <ListItemText secondary="Edit Number Status" />
                </ListItem>
              </List>
            </Collapse>

            <ListItem button onClick={handleClickOps}>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <OpenWithIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.text }}
                primary="Admin Operations"
              />
              {openOps ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openOps} timeout="auto" unmountOnExit>
              <List component="div">
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/testingNumbers"
                >
                  <ListItemText secondary="Testing Numbers" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/endpointAuditTeams"
                >
                  <ListItemText secondary="Teams Endpoint Audit" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/range/manage"
                >
                  <ListItemText secondary="Range Management" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/pool/manage"
                >
                  <ListItemText secondary="Pool Management" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/site/manage"
                >
                  <ListItemText secondary="Site Management" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/reviewOrderHistory"
                >
                  <ListItemText secondary="Review Bulk Order" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/rangeAudit"
                >
                  <ListItemText secondary="Range Audit" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/poolAudit"
                >
                  <ListItemText secondary="Pool Audit" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/siteAudit"
                >
                  <ListItemText secondary="Site Audit" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/carrier/manage"
                >
                  <ListItemText secondary="Carrier Maintenance" />
                </ListItem>

                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/syncfromTeams"
                >
                  <ListItemText secondary="Sync from Teams" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  component={Link}
                  to="/runSiteDataSync"
                >
                  <ListItemText secondary="Run Site Data Sync Audit" />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </div>
      </Drawer>
    </div>
  );
}
